import React from 'react';
import { SVGS } from '../../../assets';
import './transporter-vehicle-details.scss';
import { InputWrapper } from '../input-wrapper';

const transporter_Vehicle_Details = [
  {
    key: 'transporterName',
    label: 'Enter the delivery destination of the customer',
    placeholder: 'Enter Transporter Name',
    icon: SVGS.Truck,
  },
  {
    key: 'vehicleNumber',
    label: 'What is the Vehicle Number?',
    placeholder: 'Enter Vehicle Number',
    icon: SVGS.Steering,
  },
  {
    key: 'driverName',
    label: 'Provide the driver name',
    placeholder: 'Enter Driver Name',
    icon: SVGS.DriverIcon,
  },
  {
    key: 'driverPhone',
    label: '',
    placeholder: 'Enter Driver Ph. No',
    icon: SVGS.PhoneIconBlack,
    type: 'tel',
  },
];

interface TransporterVehicleDetailsProps {
  formData: Record<string, string | string[]>;
  onChange: (key: string, value: string) => void;
}

export const TransporterVehicleDetails: React.FC<
  TransporterVehicleDetailsProps
> = ({ formData, onChange }) => {
  return (
    <div className="transporter-details">
      {transporter_Vehicle_Details.map((field) => (
        <div key={field.key} className="transporter-details--field">
          {field.label && (
            <label className="transporter-details--label font-medium">
              {field.label}
            </label>
          )}

          <InputWrapper
            icon={field.icon}
            placeholder={field.placeholder}
            value={(formData[field.key] as string) ?? ''}
            onChange={(value) => onChange(field.key, value)}
            type={field.type}
          />
        </div>
      ))}
    </div>
  );
};
